import { render } from "./quotes.vue?vue&type=template&id=9222c252&scoped=true"
import script from "./quotes.vue?vue&type=script&lang=js"
export * from "./quotes.vue?vue&type=script&lang=js"

import "./quotes.vue?vue&type=style&index=0&id=9222c252&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9222c252"]])

export default __exports__